

























import CreateDialog from '@/components/CreateDialog.vue'
import { VueForm } from '@/utils/interfaces'
import { editMixin } from '@/utils/mixins/editMixin'
import mixins from 'vue-typed-mixins'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { PropType } from 'vue'
import { number } from '@/utils/validators'

export default mixins(editMixin, crudMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
  },
  props: {
    sign: String as PropType<'plus' | 'minus'>,
  },
  data() {
    return {
      rules: {
        number: (v: string) =>
          number(v) || this.$t('validation.must-be-a-number'),
        required: (v: string) => !!v || this.$t('validation.field-required'),
      },
      crud: {} as { topup_credit: number },
      defaultCrud: {
        topup_credit: 0,
      },
      credit: '',
      loading: false,
    }
  },
  methods: {
    async onSuccess(): Promise<void> {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      let value = Number(this.credit)
      if (this.sign === 'minus') {
        value = value * -1
      }
      this.editedItem.topup_credit =
        Number(this.editedItem.topup_credit) + value
      this.$emit('new-item', this.editedItem)
      this.$emit('input', false)
      form.reset()
    },
  },
})
